import React from 'react'

export default function VisiGiftWatchHistory() {
  return (
    <div>VisiGiftWatchHistory</div>
  )
}
